import TOKEN_LOGO from '@assets/token-coloured.svg';
import { HStack, Image, Text } from '@chakra-ui/react';
import { ADDRESS_ZERO } from '@utils';
import { MetamaskToken } from '@web3react';
import { useChainManager } from '../../chain/hooks/useChainManager';
import { getChainConfig } from '../../config/chains';
import { round } from 'lodash';
import React from 'react';

export interface FormatTokenProps {
  iconW?: number;
  iconH?: number;
  color?: string;
  fontSize?: number;
  fontWeight?: number | 'string';
  amount: number;
  token: Omit<MetamaskToken, 'decimals'> | undefined;
  currency?: string;
}
export const FormatToken: React.FunctionComponent<FormatTokenProps> = ({
  amount,
  token,
  iconH = 8,
  iconW = 8,
  color = 'white',
  fontSize = 28,
  fontWeight = 700,
  currency,
}) => {
  const { currentChain } = useChainManager();
  const chainConfig = getChainConfig(currentChain as 'bnb' | 'solana');
  const nativeSymbol = chainConfig.symbol; // 'BNB' or 'SOL'

  // Get token symbol, only hide if it's a shortened address (contains '...')
  // Always show symbol if it exists, even if it's 'UNKNOWN' (might be actual token symbol)
  const tokenSymbol = token?.symbol 
    ? (token.symbol.includes('...') 
        ? '' // Hide only if it's a shortened address pattern
        : token.symbol.toUpperCase())
    : '';

  // Debug log to check token values
  if (amount > 0 && currency) {
    console.log('FormatToken - Token info:', {
      token,
      tokenSymbol,
      hasSymbol: !!token?.symbol,
      symbolValue: token?.symbol,
    });
  }

  // Get token logo, fallback to default logo if not available
  const tokenLogo = token?.logo || TOKEN_LOGO;

  return (
    <HStack>
      {currency !== ADDRESS_ZERO ? (
        <Image 
          src={tokenLogo} 
          w={iconW} 
          h={iconH}
          onError={(e) => {
            // Fallback to default logo if image fails to load
            (e.target as HTMLImageElement).src = TOKEN_LOGO;
          }}
        />
      ) : null}
      <Text fontSize={fontSize} fontWeight={fontWeight} color={color}>
        {amount > 0
          ? `${round(amount * 0.8, 7)}${tokenSymbol ? ` ${tokenSymbol}` : ''} (+0.01 ${nativeSymbol})`
          : `0.01 ${nativeSymbol}`}
      </Text>
    </HStack>
  );
};

export default FormatToken;
